import React from 'react';
import { Spacer } from '../Spacer';
import { Typography } from '../Typography';

export const PropertiesError = ({ error }) => {
  console.warn(error);
  return (
    <Spacer>
      <Typography component="h2" variant="lead">
        Sorry, we are having trouble searching for properties right now.
        <br />
        Please try again later.
      </Typography>
    </Spacer>
  );
};
